/**
 * Render a Skysight-style "LCL" pill at the lifted condensation level.
 *
 * Skysight specs (decoded from live DOM 2026-05-26):
 *   - Pill: 22w × 16h, rx=8, fill rgb(37, 99, 235), opacity 0.9, NO stroke
 *   - Leader line: 15px wide extending RIGHT from pill, stroke rgb(37,99,235), width 2
 *   - Label "LCL": font-size 10px, font-weight bold, fill white, text-anchor middle
 *
 * @param {import('d3-selection').Selection} container
 * @param {import('../skewt/scales.js').Scales} scales
 * @param {number} tlcl  LCL temperature, °C
 * @param {number} plcl  LCL pressure, hPa
 */
export function drawLCLMarker(container, scales, tlcl, plcl) {
    container.selectAll('.skewt-ext-lcl-marker').remove();
    if (!Number.isFinite(tlcl) || !Number.isFinite(plcl)) return;

    const cx = scales.skewX(tlcl, plcl);
    const cy = scales.y(plcl);

    const g = container.append('g').attr('class', 'skewt-ext-lcl-marker');

    // Skysight color: rgb(37, 99, 235) (= Tailwind blue-600)
    const COLOR = 'rgb(37, 99, 235)';
    const PILL_W = 22;
    const PILL_H = 16;
    const LEAD = 15;
    // Skysight layout: pill sits to the LEFT of the LCL point with a 15px
    // leader pointing RIGHT, ending exactly at the LCL point (cx). So the
    // pill's right edge is at `cx - LEAD`, leader from there to `cx`.
    const pillX = cx - LEAD - PILL_W;
    const pillY = cy - PILL_H / 2;

    // Leader line — from pill right edge to the LCL point
    g.append('line')
        .attr('x1', pillX + PILL_W)
        .attr('x2', cx)
        .attr('y1', cy)
        .attr('y2', cy)
        .style('stroke', COLOR)
        .style('stroke-width', '2');

    // Pill — no stroke, opacity 0.9
    g.append('rect')
        .attr('x', pillX)
        .attr('y', pillY)
        .attr('width', PILL_W)
        .attr('height', PILL_H)
        .attr('rx', 8)
        .style('fill', COLOR)
        .style('opacity', '0.9');

    // Label
    g.append('text')
        .attr('x', pillX + PILL_W / 2)
        .attr('y', cy + 4)
        .attr('text-anchor', 'middle')
        .style('font-size', '10px')
        .style('font-weight', 'bold')
        .style('fill', 'white')
        .style('pointer-events', 'none')
        .text('LCL');
}
